import React from 'react'
import { useIntl } from 'react-intl'
import IconArrowRight from 'client/icons/ChevronRight'
import styles from './styles.module.css'
import cn from 'classnames'

interface IbuttonProps {
  text: string
  hasChevron?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  className?: string
}

const ButtonLink = ({ text, hasChevron, className, ...props }: IbuttonProps) => {
  const intl = useIntl()

  return (
    <button type="button" className={cn(styles.buttonLink, className)} {...props}>
      {intl.formatMessage({ id: text })}
      {hasChevron && <IconArrowRight size={16} />}
    </button>
  )
}

export default ButtonLink
